export default __webpack_public_path__ + "static/media/Harbinger of Acheron.a7642907.jpg";